import qs from 'qs';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { get } from 'lodash';

import Loading from '../../components/Loading/index';
import { getAccessToken } from '../../redux/auth/auth.selectors';

interface ILocationHash {
  state: string;
}

// Tenancy's Google callback sets the session cookie and redirects here. App restores the token from that cookie
// before this renders, so a missing token means the sign-in left no session.
const AuthenticateView = ({ location, history }: RouteComponentProps) => {
  const accessToken = useSelector(getAccessToken);
  const params: ILocationHash = qs.parse(location.hash.substr(1));
  const redirectStateParam = get(params, 'state');

  useEffect(() => {
    if (accessToken) {
      const url = redirectStateParam || '/reposits';
      history.push(url);
    } else {
      history.push('/unauthorised');
    }
  }, [history, accessToken, redirectStateParam]);

  return <Loading />;
};

export default AuthenticateView;
